<section [style]="{ width: this.width+'px', height: this.Height+'px' }">
    <ng-content></ng-content>
  </section>
  
